/**
 * Copyright 2026 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

import { Skeleton } from '@az/starc-ui';
import styles from './ProductDescSpecSkeletonV2.module.scss';

export default function ProductDescSpecSkeletonV2() {
  return (
    <div className={styles.container} data-testid="product-description-skeleton">
      <Skeleton className={styles.skeletonTitle} />
      <Skeleton className={styles.skeletonIcon} borderRadius="round" />
    </div>
  );
}
